export default "__VITE_ASSET__BL2SRq3P__"